export default {
  lang: '영어',
  homeScreen: {
    title: '귀하의 꿈을 이루세요',
    stayConnected: '지속적으로 연락하세요:',
    download: '지금 다운로드',
  },
  notification: {
    newAndNow: '새로운 소식!',
    alert: '알림',
    message: '메시지',
    contest: '콘테스트',
    badge: '새 배지',
    'content-update': '콘텐츠 업데이트',
    events: '이벤트',
  },
  loginScreen: {
    version2: {
      homeTitle:
        '시스템에서 회원님의 기존 프로필을 찾을 수 있는지 확인해 보겠습니다.',
      homeTitleSub:
        '교육 프로그램에 로그인할 때 일반적으로 사용하는 이메일 주소를 입력합니다.',
      noAccount:
        '계정을 찾을 수 없습니다({이메일}). 다른 이메일로 시도하거나 지금 계정을 만드세요.',
      continueButton: '계속',
      success:
        '계정을 성공적으로 업데이트했습니다! 곧 홈 페이지로 리디렉션됩니다.',
      successNewAccount:
        '등록을 완료하면 계정 확인을 위한 확인 이메일을 받게 됩니다.',
      loginButton: '로그인',
      matchFound:
        '일치하는 항목을 찾았습니다. 계속하려면 비밀번호를 입력하세요.',
      magicLink: '이메일에 포함된 링크를 통해 로그인합니다:',
      magicLinkButton: '매직 링크 요청하기',
      magicLinkTitle:
        '즉시 로그인할 수 있는 직접 링크를 이메일로 전송받으세요.',
      otherEmailButton: '제출',
      title:
        '개인 프로필과 연락처 정보가 입력되므로 잠시 시간을 내어 아래의 모든 정보를 입력해 주세요.',
      titleIndustry:
        '개인 프로필과 연락처 정보가 입력되므로 잠시 시간을 내어 아래의 모든 정보를 입력해 주세요.',
      register: '계정 만들기',
      agent: '여행 어드바이저',
      visitor: '업계 방문자',
      step1: '1단계: 사용자 유형',
      step2: '2단계: 계정 만들기',
      step3: '3단계: 프로필 만들기',
      marketingOptIn:
        '이 프로그램의 여행 무역 팀과 계속 연락하고 싶지 않으세요?',
      optIn: '예, 관심 있습니다',
      optOut: '관심 없음',
      step2Sub1: '귀사에 대해 알려주세요',
      step2Sub2: '귀사의 비즈니스에 대해 알려주세요.',
      privacyHead: '커뮤니케이션 기본 설정',
      privacySub:
        '아래 확인란을 선택하여 공급업체의 여행사 팀으로부터 중요한 커뮤니케이션(상품 업데이트 및 공지사항, 보상, 인센티브, FAM 등)과 여행사 네트워킹 및 영업 지원 이니셔티브를 트래프로 모바일에서 받아보시기 바랍니다.',
      privacy:
        '당사는 사용자의 개인정보를 보호하며 사용자의 신뢰를 판매, 오용 또는 배신하지 않습니다.',
      store: '앱 스토어에서 이 프로그램을 쉽게 다운로드할 수 있습니다:',
      powered: '제공처',
      toastMessage: {
        forgotSuccess:
          '비밀번호 재설정 링크를 이메일로 보내드렸습니다! 10초 후 로그인 페이지로 리디렉션됩니다.',
        emailNotExisting: '입력하신 이메일 주소가 존재하지 않습니다.',
        magicLinkMessage: '잠시만요, 지금 로그인하는 중입니다.',
        magicLinkError:
          '데이터베이스에서 회원님의 계정을 찾을 수 없습니다. 수동으로 로그인해 주세요. 10초 후에 리디렉션됩니다.',
        magicLinkError1:
          '유효한 토큰을 찾을 수 없습니다. 로그인하거나 새로운 매직 링크를 요청해 주세요. 이 문제가 지속되면 info@travpromobile.com 으로 문의하시기 바랍니다.',
        magicLinkError2:
          '데이터베이스에서 회원님의 계정을 찾을 수 없습니다. 수동으로 로그인해 주세요. 10초 후에 리디렉션됩니다.',
        magicLinkSuccess:
          '이메일{이메일}에서 이메일을 확인하세요. 로그인할 수 있는 매직 링크가 있습니다.',
        magicLinkErrorWait: '매직링크 요청 사이에는 5분 정도 기다려 주세요.',
        emailNotFoundError:
          '입력하신 이메일 주소를 기록에서 찾을 수 없습니다. 철자가 틀렸는지 확인하거나 계정을 새로 만드세요.',
      },
      errors: {
        zipCodeNotFound: '우편번호를 찾을 수 없습니다, 다시 시도하세요',
        zipCodeOnlyNumbers: '우편번호는 숫자만 포함할 수 있습니다.',
        password: '비밀번호를 입력하세요.',
        passwordNotMatching: '입력한 비밀번호가 일치하지 않습니다.',
        passwordTooShort: '비밀번호는 8자 이상이어야 합니다.',
        emailExists:
          '이 이메일 주소는 이미 존재하거나 유효하지 않습니다. 다른 이메일 주소로 시도하거나 계정에 로그인하세요.',
        fillInAllFields: '필수 입력란을 모두 기입해 주세요.',
        fillInEmail: '이메일을 입력해 주세요.',
        emailNotExisting: '입력하신 이메일 주소가 존재하지 않습니다.',
      },
      fields: {
        forgotSubCopy: '비밀번호를 잊어버려서 변경하고 싶으신가요? ',
        forgotSubCopy2:
          '비밀번호를 완전히 우회하고 싶으신가요? 자동으로 프로그램에 로그인할 수 있는 매직 링크가 포함된 이메일을 보내드립니다.',
        city: '도시',
        companyName: '회사 이름',
        role: '귀하의 역할',
        description: '귀사의 비즈니스를 가장 잘 설명하는 것은 무엇인가요?',
        country: '국가',
        password: '비밀번호',
        passwordRegister: '비밀번호 선택(최소 8자)',
        passwordConfirm: '비밀번호 확인',
        firstName: '이름(제공됨)',
        lastName: '성(가족)',
        agency: '대행사 이름',
        title: '역할(하나 선택)',
        company: '회사 이름',
        select: '아래에서 옵션을 선택하세요.',
        state: '상태',
        province: '시/도/지역/주',
        zipCode: '우편 번호',
        postalCode: '우편 번호',
        affiliate: '주요 대행사 소속은 어느 그룹인가요?',
        hostAgency: '호스트 에이전시?',
        executive: '임원',
        management: '관리',
        marketing: '마케팅',
        sales: '판매',
        coordinator: '코디네이터',
        opt: '이 프로그램의 여행 무역 팀과 계속 연락하여 업데이트를 받아보세요.',
        optMarketing:
          '유사한 프로그램 및 이벤트와 관련하여 트래블프로와 계속 소통하세요.',
        retail: '소매점 매장 전면',
        home: '재택 근무 상담원',
        independent: '독립 계약자',
        host: '호스트 대행사',
        call: '콜센터 또는 웹 기반 대행사',
        other: '기타',
        describes:
          '귀하와 귀하의 에이전시의 비즈니스를 가장 잘 설명하는 것은 무엇인가요?',
      },
    },
    title: '여행전문가 교육 및 판매지원 프로그램',
    welcome: {
      headerTop: '환영합니다',
      headerBottom:
        '캘리포니아 방문 스타 판매 도우미(Visit California STAR Sales Companion)에 오신 것을 ',
    },
    sellingPoints: [
      '일상 판매전환 리소스',
      '놀랍고 신비한 디스커버리 및 프리젠테이션',
      '‘즐겨찾기’ 폴더를 설정하세요',
      '온라인, 오프라인 - 언제 어디서나 가능',
      '공유, 연결, 전환할 수 있습니다.',
    ],
    emailPrompt: '이메일을 입력하시고 여행 전문가가 되시기 바랍니다.',
    tAndC: {
      agree: '계속 진행하면 귀하는 동의하는 것입니다. ',
      privacyPolicy: '우리의 개인정보 보호정책',
      and: ' 과 ',
      termsConditions: '이용 약관에',
    },
    fields: {
      agency: '대행사',
      email: '이메일',
      firstName: '이름',
      lastName: '성',
      agencyName: '대행사 이름',
      stateProvince: '주/도',
      registrationCode: '프로모션 코드 (선택 사항)',
      required: '필수',
      invalidEmail: '이메일 주소가 잘못되었습니다.',
      opt: '연락을 유지하다! 예, 뉴스, 이벤트, 인센티브, FAM 등에 대한 소식을 계속 알려줄 Visit California의 커뮤니케이션을 선택하고 싶습니다!',
      forgot:
        '비밀번호를 잊으셨나요? 아래 버튼을 클릭하면 비밀번호를 재설정할 수 있는 이메일이 전송됩니다.',
    },
    forgot: '비밀번호 재설정',
    noAgent: {
      noAgentButton: '저는 어드바이저가 아닙니다.',
      title: '캘리포니아 스타를 사랑해 주셔서 감사합니다.',
      messageWeb:
        '이 사이트는 여행 전문가 전용 콘텐츠입니다. \n 캘리포니아 스타에 대한 자세한 내용을 보려면 다음을 방문하세요. ',
      messageMobile:
        "이 앱의 일부 콘텐츠는 여행 전문가 전용이지만, '계속'을 누르면, 이 앱의 내용을 미리보기 형식으로 탐색할 수 있습니다.",
      continue: '계속',
      visitWebsite: '웹 사이트 방문>',
    },
    newUser: '신규 사용자',
    register: '등록',
  },
  welcomeScreen: {
    title:
      '캘리포니아 스타 교육 프로그램 및 판매 도우미에 오신 것을 환영합니다',
    helloUser: '{name}님, 안녕하세요.',
    hello: '안녕하세요,',
    fromAgency: '{agency}에서',
    notUser: '{name}이 아닌가요?',
    introOnline:
      '온라인으로 즉시 교육을 받으시거나, 콘텐츠를 미리 설치하여 오프라인에서 교육을 받을 수 있습니다!',
    introOffline:
      '이미 최신 버전이 설치되어 있습니다. 교육 또는 판매를 언제 어디서나 시작하세요!',
    startTraining: '교육을 시작합니다',
    downloader: {
      preload: '설치 중입니다',
      stop: '정지',
      init: '초기화 중입니다...',
      lastUpdate: '마지막 업데이트: ',
    },
  },
  trainingScreens: {
    review: '재조사하다',
    chapter: '챕터',
    start: '시작',
    continue: '계속',
    welcome:
      '새롭게 디자인 된 교육 섹션에 오신 것을 환영합니다. 골드 CA STAR가되는 궁극적 인 목표를위한 포인트를 얻으려면 모듈을 완료하기 만하면됩니다! 오른쪽에있는 막대는 현재 진행 상황을 정확히 보여줍니다!',
    restart: '재시작',
    durationInMinutes: '{number}분',
    percentageComplete: '{number}% 완료',
    unlock: '교육 챕터{number}를 완료하면 이 챕터가 열립니다.',
    unlockSpecialization: '기본 과정을 완료하여 이 장을 잠금 해제하세요',
    unlockSubtitle:
      '여러 교육 챕터를 완료하여 다른 챕터들의 이용 권한을 많이 확보하세요.',
    allUnlocked: '이제 모든 챕터를 이용하실 수 있습니다!',
    certificate: '증명서',
    courseComplete: '코스를 마쳤습니다!',
    chapterComplete: '챕터 완료!',
    message: '{count} 스타 메시지',
    messagePlural: '{count} 스타 메시지',
    endReached: '모든 과정을 마쳤습니다',
    retainEnd:
      '상단 막대를 사용하여 본 챕터를 탐색하거나, ‘뒤로’ 버튼을 눌러 ‘개요’로 돌아갑니다.',
    watchListenRead: '다양한 영상, 음성 및 문서 정보',
    trouble: '답하기 어려우신 것 같은데, 이 질문을 건너 뛰겠습니까?',
    confirm: '답을 확인하십시오',
    choose: '답을 선택하십시오',
    essential: '필수 모듈',
    essentialSub: '해당 모듈을 완성하여 Bronze CA STAR 상태를 획득하세요',
    specialization: '특수 모듈',
    specializationSub: '해당 모듈을 완성하여 Silver CA STAR 상태를 달성하세요',
    status: '현재 상태',
  },
  nav: {
    home: '홈',
    train: '기차',
    retain: '유지',
    directory: '디렉토리',
    promote: '홍보',
    sell: '판매',
    info: '정보',
    media: '미디어',
    favorites: '즐겨찾기',
    contact: '연락처',
    reportCard: '성적표',
    accountSettings: '계정 설정',
    messages: '스타 메시지',
    search: '검색',
    showcases: '쇼케이스',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  contentHeaders: {
    train: '교육 라이브러리',
    retain: '리테인',
    subapps: '캘리포니아 파트너 미니 모듈',
    maintrainings: '재단',
    subtrainings: '경험',
  },
  pageDescriptions: {
    train: '교육, 참여, 전문가가 되세요.',
    retain:
      '전문가적인 지식을 유지하고 판매 노력을 가능하게 하는 당신의 필수 자원입니다. 제품에 대한 질문에 전문적으로 대답하거나 즉석에서 판매 프레젠테이션으로 사용하세요 - 언제 어디서나 모든 기기에서 가능합니다.',
    promote: '귀하의 고객 및 잠재 고객과 대화를 시작하세요.',
    sell: '모든 미디어 자산 및 판매 담보는 액세스 및 공유가 쉽도록 잘 정돈되어 있습니다.',
    favorites: '즐겨 찾는 콘텐츠를 확인하세요.',
    search: '모든 콘텐츠 살펴보기',
    subapps: '파트너로부터 자세한 내용보기',
    maintrainings: '이 필수 챕터를 완료하고 디플로마를 획득하세요!',
    subtrainings: '아래의 각 전문 체험을 완료하여 배지를 획득하세요.',
  },
  general: {
    showcase: 'Showcases',
    next: '다음',
    previous: '이전',
    submit: '제출',
    back: '뒤로',
    close: '닫기',
    page: '페이지 ',
    search: '검색',
    logIn: '로그인',
    logOut: '로그 아웃',
    viewItem: '보기{type}',
    imageNotFound: '이미지를 찾을 수 없음',
    noResultsFor: '결과를 찾을 수 없습니다: {query}',
    noFavorites: '등록된 즐겨찾기가 없습니다.',
    noMessages: '받은 메시지가 아직 없습니다!',
    resultsFor: '에 대한 검색 결과: {query}',
    showAll: '모두 보이기',
    connectionError: '연결 오류',
    alreadyExists: '이미 존재함',
    pageNotFound: '404 페이지를 찾을 수 없습니다!',
    oops: '오류가 생긴 것 같습니다.',
    overview: '개요로 돌아가기',
    complete: '코스를 마쳤습니다!',
    share: '공유',
    destinations: '캘리포니아 파트너 미니 교육',
    essentials: '캘리포니아 에센셜',
    trainingLibrary: '교육 라이브러리',
    message: '{count} 스타 메시지',
    messagePlural: '{count} 스타 메시지',
    badge: '배지',
  },
  itemTypes: {
    image: '이미지',
    brochure: '콜렉션',
    layout: '레이아웃',
    web: '웹 사이트',
    pdf: 'PDF',
    carousel: '콜렉션',
  },
  questions: {
    dials: '대답과 일치하도록 다이얼을 돌리세요',
    fitb: '공란에 기입하세요',
    flip: '대답과 일치하도록 번호를 변경하세요',
    multipleChoice: '정답(들)을 고르세요',
    slider: '슬라이더를 사용하여 정답을 고르세요',
    map: '지도에서 올바른 위치를 터치하여 질문에 답하십시오.',
    dropdown: '선택하세요...',
    true: '맞습니다',
    false: '아닙니다',
  },
  cookies: {
    consent: '동의',
    optout: '옵트 아웃',
    settings: '개인정보 설정',
    message:
      '귀하께서는 데이터 개인정보 환경설정에 대해 저희에게 아무 것도 알려주지 않았습니다. 그래도 문제될 것은 없습니다만, 저희는 판매 도우미를 통해 귀하께 최상의 경험을 제공하고자 합니다.',
    disabled: '귀하의 앱에 쿠키사용 기능이 꺼져 있는 것 같습니다.',
    use: '최고의 경험을 누리려면 {appName}에 쿠키사용 기능이 켜져 있어야 합니다.',
    details: '쿠키가 사용되는 이유는 무엇입니까?',
    enable: '{here} 쿠키를 활성화하는 방법을 참조하십시오.',
    here: '여기',
  },
  notLoggedIn: {
    super: '로그인하지 않았습니다.',
    title: '이 콘텐츠를 보려면 로그인해야 합니다.',
    guest: '게스트',
  },
  demo: {
    message:
      '이 웹 사이트는 완성품의 데모 버전입니다. 현재 개발 중이며 완성품은 아닙니다.',
    consent: '네. 그렇군요!',
  },
  share: {
    header: '귀하께서 자주 이용하는 소셜 미디어에 본 리소스를 공유하세요!',
    download: '다운로드',
  },
  breadCrumbs: {
    page: '페이지',
  },
  onMobile: {
    header: '귀하께서는 휴대 기기에서 {appName}앱에 액세스 하려는 것 같습니다.',
    body: '이 프로그램을 다운로드하려면 앱 스토어에서 {appName}을(를) 검색하거나 아래 버튼 중 하나를 클릭하십시오.',
    benefits: {
      header: '본 앱은 귀하에게 다음을 제공할 것입니다:',
      1: '휴대성',
      2: 'WiFi 없이 언제 어디서나 편리하게 훈련할 수 있습니다.',
      3: '판매 도구 및 리소스를 손쉽게 이용할 수 있습니다.',
    },
  },
  sharing: {
    twitter: '다음 휴가는 꼭 캘리포니아에서 보내시기를 바랍니다...',
    imageEmailSubject: '당신의 꿈을 위해, 캘리포니아 스타 드림 휴가 아이디어',
    imageEmailCopy:
      '첨부된 캘리포니아 스타 휴가 컨텐츠를 잠깐 살펴보십시오... 만끽하세요!',
    videoEmailSubject: '내가 공유한 멋진 캘리포니아 STAR 휴가 아이디어',
    videoEmailCopy:
      '이 캘리포니아 스타 휴가 비디오가 마음에 들 것입니다. 아래 링크를 클릭하여 비디오를 감상하세요.  만끽하세요!',
    infographicEmailSubject: '캘리포니아 STAR 휴가 아이디어에 관해 공유하기...',
    infographicEmailCopy:
      '흥미가 있을 것입니다. 잠시 시간을 내어 첨부된 내용을 살펴보세요.   또 만나뵐게요!',
    copyURL: '링크 복사',
    copied: '복사됨',
  },
  newTrainingFlow: {
    tip: '팁: 각 티어 내 모듈을 완성하여 상태를 획득하게 됩니다.  꿈을 크게 가지시고 모든 모듈을 완성하여 Gold CA STAR까지 올라가보세요!',
    essentialModules: '필수 모듈',
    finishBronze: '해당 모듈을 완성하여 Bronze CA STAR 상태를 획득하세요',
    specializationModules: '특수 모듈',
    finishSilver: '해당 모듈을 완성하여 Silver CA STAR 상태를 달성하세요',
    partnerModules: '파트너 모듈',
    finishGold: '해당 모듈을 완성하여 Gold CA STAR 상태를 달성하세요',
    currentStatus: '현재 상태',
    pointsToLevel: '{pointsToLevel} {points} ',
    reachedRanking: '{rank}  랭킹까지 남았습니다!',
    outOf: '{points}  XP 전체 포인트',
    pointsToRank: '{pointsToLevel} XP가 필요합니다:  ({rank})',
  },
  points: {
    completed: '{completed} / {total} 완료',
  },
  new: {
    achievements: '성취',
  },
  badgeView: {
    title: '교육 성과',
    subtitle:
      '디플로마 및 전문성 배지를 보고, 추적하고, 다운로드할 수 있는 업적 대시보드에 오신 것을 환영합니다.',
    badgeDisplayTitle: '메탈릭 업적 상태',
    badgeAchievement:
      '당신은 달성했습니다{rank}상태를 달성했습니다! 오른쪽의 아이콘을 클릭하여 상태를 확인하고 공유하세요.',
    bronze: '브론즈',
    silver: '실버',
    gold: '골드',
    platinum: '플래티넘',
    complete: '완료',
    diploma: '디플로마',
    chapterBadges: '전문 분야 배지',
    partnerBadges: '파트너 배지',
  },
  badgeDisplay: {
    status: '교육 성취도 상태',
  },
  search: {
    pages: '頁面',
    resources: '資源',
  },
};
